import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepperItemInterface } from '../../interfaces/stepper-item.interface';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  @Input() stepperItem: StepperItemInterface;
  @Input() largeFont: boolean;
  @Input() shortHeight: boolean;
  @Input() selected: boolean;
  @Input() isDisabled: boolean;
  @Input() finished: boolean;
  @Output() clickEvent = new EventEmitter();

  get iconName() {
    return this.finished ? 'completo' : 'flecha_direita';
  }

  public emitClick(force = false) {
    if ((!this.isDisabled && !this.finished) || force) {
      this.clickEvent.emit();
    }
  }
}
